
export default function AuthoritySection() {
  const authorities = [
    {
      title: '中国普洱茶产业发展报告',
      subtitle: '案例企业',
      icon: 'ri-file-text-line',
      color: 'from-blue-500 to-blue-600'
    },
    {
      title: '凤凰卫视《凤凰观茶家》',
      subtitle: '联合制作方',
      icon: 'ri-tv-line',
      color: 'from-slate-500 to-slate-600'
    },
    {
      title: '云南农科院茶叶研究所',
      subtitle: '合作单位',
      icon: 'ri-microscope-line',
      color: 'from-blue-400 to-blue-500'
    },
    {
      title: '京东物流',
      subtitle: '战略合作伙伴',
      icon: 'ri-truck-line',
      color: 'from-gray-500 to-gray-600'
    }
  ];

  return (
    <section id="authority" className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="container mx-auto px-6 lg:px-16 xl:px-24">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            权威背书 · 实力认证
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-2xl mx-auto">
            与行业顶尖机构深度合作，为您提供最权威的品质保障
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {authorities.map((authority, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 text-center group hover:transform hover:scale-105"
            >
              <div className={`w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-r ${authority.color} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${authority.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-gray-800 mb-2 leading-tight">
                {authority.title}
              </h3>
              <p className="text-sm md:text-base text-blue-600 font-medium">
                {authority.subtitle}
              </p>
            </div>
          ))}
        </div>

        {/* Stats section */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-white">
          <div className="grid grid-cols-2 md:grid-cols-6 gap-6 text-center">
            <div>
              <div className="text-xl md:text-3xl font-bold text-blue-200 mb-1">500+</div>
              <div className="text-xs md:text-base text-blue-100">合作工厂</div>
            </div>
            <div>
              <div className="text-xl md:text-3xl font-bold text-blue-200 mb-1">20+</div>
              <div className="text-xs md:text-base text-blue-100">独家品牌</div>
            </div>
            <div>
              <div className="text-xl md:text-3xl font-bold text-blue-200 mb-1">5万+㎡</div>
              <div className="text-xs md:text-base text-blue-100">仓储面积</div>
            </div>
            <div>
              <div className="text-xl md:text-3xl font-bold text-blue-200 mb-1">10万+</div>
              <div className="text-xs md:text-base text-blue-100">日发单量</div>
            </div>
            <div>
              <div className="text-xl md:text-3xl font-bold text-blue-200 mb-1">20+</div>
              <div className="text-xs md:text-base text-blue-100">专利技术</div>
            </div>
            <div>
              <div className="text-xl md:text-3xl font-bold text-blue-200 mb-1">50+</div>
              <div className="text-xs md:text-base text-blue-100">专家团队</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
